import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import {
  ESTADOS,
  USUARIOS_FISCALIZACION,
  ROLES_USUARIO,
  CONFIGURACION_SISTEMA
} from 'constants/nombresCatalogos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { Form, Row, Select, DatePicker, Col } from 'antd';
import { Button, Loader } from 'components';
import { DATE_FORMAT_FILTER_COLUMN } from 'utils/date';
import * as fieldMsgs from 'constants/formFieldsMessages';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import ModalCantidadUsuariosRol from './ModalCantidadUsuariosRol';
import './BuscadorUsuarios.scss';

export const BuscadorUsuarios = ({ onSearch }) => {
  const [searchForm] = Form.useForm();
  const estados = useSelector(selectCatalogByName(ESTADOS));
  const [loadingFilters, setLoadingFilters] = useState(true);
  const usuariosFisca = useSelector(selectCatalogByName(USUARIOS_FISCALIZACION));
  const roles = useSelector(selectCatalogByName(ROLES_USUARIO));
  const [isModalConteos, setIsModalConteos] = useState(false);
  const catRolesInicial = roles.filter(
    (rol) =>
      !rol.nombre.includes('VVGP') &&
      !rol.nombre.includes('SIF') &&
      !rol.nombre.includes('CONSULTA')
  );
  const catRoles = catRolesInicial.map((rol) => ({
    ...rol,
    descripcion: rol.descripcion.replace('Oficina Central', '')
  }));
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    if (
      estados !== undefined &&
      estados.length > 0 &&
      usuariosFisca !== undefined &&
      usuariosFisca.length > 0 &&
      catRoles !== undefined &&
      catRoles.length > 0
    ) {
      setLoadingFilters(false);
    }
  }, [estados, usuariosFisca, catRoles]);

  const handleSearchByFilters = async () => {
    try {
      const params = await searchForm.validateFields();
      if (params.fechas && params.fechas.length === 2) {
        params.fecha_inicio = params.fechas[0].format('YYYYMMDD');
        params.fecha_fin = params.fechas[1].format('YYYYMMDD');
        delete params.fechas;
      }
      onSearch(params);
    } catch (error) {
      /* empty */
    }
  };

  const handleClearFilters = () => {
    searchForm.resetFields();
    onSearch({});
  };

  return (
    <div className="buscador-monitoreo">
      {loadingFilters ? (
        <Loader />
      ) : (
        <>
          <Form form={searchForm} layout="horizontal">
            <Row gutter={24}>
              <Col xs={5}>
                <span className="buscador-monitoreo-etiqueta">
                  <span style={{ color: 'red' }}>&#42;</span>Entidad:
                </span>
                <Form.Item
                  name="idEntidades"
                  className="buscador-monitoreo-etiqueta"
                  rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                  {loadingFilters ? (
                    <Loader />
                  ) : (
                    <Select
                      placeholder="Selecciona"
                      allowClear
                      mode="multiple"
                      showSearch
                      loading={loadingFilters}
                      options={estados}
                      filterOption={(inputValue, option) =>
                        option.nombreEstado?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      fieldNames={{
                        value: 'idEstado',
                        label: 'nombreEstado'
                      }}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col xs={5}>
                <span className="buscador-monitoreo-etiqueta">Usuario:</span>
                <Form.Item name="idUsuarioFisca" className="buscador-monitoreo-etiqueta">
                  <Select
                    placeholder="Selecciona"
                    allowClear
                    showSearch
                    filterOption={(inputValue, option) =>
                      option.nombreCompleto?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    options={usuariosFisca}
                    fieldNames={{
                      value: 'idUsuario',
                      label: 'nombreCompleto'
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={5}>
                <span className="buscador-monitoreo-etiqueta">Rol:</span>
                <Form.Item name="idRol" className="buscador-monitoreo-etiqueta">
                  <Select
                    placeholder="Selecciona"
                    allowClear
                    options={catRoles}
                    fieldNames={{
                      value: 'idRol',
                      label: 'descripcion'
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={8}>
                <span className="buscador-monitoreo-etiqueta">
                  <span style={{ color: 'red' }}>&#42;</span>Rango de fechas:
                </span>
                <Form.Item
                  name="fechas"
                  className="buscador-monitoreo-etiqueta"
                  rules={[{ required: true, message: fieldMsgs.ERR_RANGE_DATE_FIELD_REQUIRED }]}>
                  <RangePicker
                    format={DATE_FORMAT_FILTER_COLUMN}
                    minDate={dayjs(fechaIniciOper, dateFormat)}
                    maxDate={dayjs(fechaHoy, dateFormat)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div className="buscador-monitoreo-acciones">
            <Button text="Limpiar" onClick={handleClearFilters} className="limpiar" />
            <span style={{ width: '1em' }} />
            <Button text="Buscar" type="primary" onClick={handleSearchByFilters} />
          </div>
          <div className="acceso-bitacora-conteos">
            <Button
              type="link"
              text="Bitácora de accesos"
              danger
              className="title-label-bitacora-conteos"
              onClick={() => setIsModalConteos(true)}
            />
          </div>
          <div>
            <ModalCantidadUsuariosRol
              open={isModalConteos}
              cerrarModalConteos={() => setIsModalConteos(false)}
            />
          </div>
        </>
      )}
    </div>
  );
};

BuscadorUsuarios.propTypes = {
  onSearch: PropTypes.func.isRequired
};
